import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Icon3D } from "@/components/landing/Icon3D";
import { fadeUp, cardReveal, cardRevealDeep } from "@/lib/animations";
import { Section, Overline, H2 } from "./JobPrimitives";
import { jobInfo, timeline } from "./jobData";

export const JobInfo = () => (
  <Section
    id="informacoes"
    className="py-16 md:py-24"
    testid="section-informacoes"
  >
    <motion.div {...fadeUp} className="max-w-3xl">
      <Overline>Informações da oportunidade</Overline>
      <H2 highlight="importantes">Informações</H2>
    </motion.div>

    <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {jobInfo.map((j, idx) => (
        <motion.article
          key={j.title}
          {...cardReveal(idx * 0.05, 0.5)}
          data-testid={`info-${idx}`}
          className="group bg-white rounded-3xl border border-[#E5EAF2] p-7 hover:shadow-[0_20px_50px_rgba(53,50,179,0.10)] hover:border-[#3787F5]/30 hover:-translate-y-1 transition-all duration-300"
        >
          <Icon3D
            icon={j.icon}
            variant={j.variant}
            size="md"
            className="mb-5 group-hover:scale-110 group-hover:-rotate-3"
          />
          <h3 className="text-lg font-bold text-[#1F2937]">{j.title}</h3>
          <p className="mt-2 text-[15px] text-[#64748B] leading-relaxed">
            {j.desc}
          </p>
        </motion.article>
      ))}
    </div>

    <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#64748B] bg-[#F6F8FB] px-4 py-3 rounded-full">
      <MapPin size={16} className="text-[#3787F5]" />
      A etapa presencial de capacitação será realizada em Vila Velha/ES.
    </div>
  </Section>
);

export const JobTimeline = () => (
  <Section
    id="como-funciona"
    className="py-16 md:py-24 bg-[#F6F8FB]"
    testid="section-como-funciona"
  >
    <motion.div {...fadeUp} className="max-w-3xl">
      <Overline>Como funciona o processo</Overline>
      <H2 highlight="do processo seletivo">Etapas</H2>
    </motion.div>

    <div className="mt-14 relative">
      <div className="hidden md:block absolute top-10 left-[12%] right-[12%] h-[2px] bg-gradient-to-r from-[#3532B3] via-[#3787F5] to-[#12DDB5] opacity-30" />
      <div className="grid md:grid-cols-4 gap-8 relative">
        {timeline.map((s, idx) => (
          <motion.div
            key={s.title}
            {...cardRevealDeep(idx * 0.08)}
            data-testid={`step-${idx}`}
            className="relative flex flex-col items-center text-center"
          >
            <div className="relative">
              <Icon3D icon={s.icon} variant={s.variant} size="xl" />
              <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gradient-to-br from-[#12DDB5] to-[#73F2B3] text-[#0b5a4a] text-sm font-extrabold flex items-center justify-center shadow-[0_6px_14px_rgba(18,221,181,0.45)] border-2 border-white">
                {idx + 1}
              </span>
            </div>
            <h3 className="mt-6 text-lg font-bold text-[#1F2937]">{s.title}</h3>
            <p className="mt-2 text-[15px] text-[#64748B] leading-relaxed max-w-[260px]">
              {s.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </Section>
);
